import React from 'react';

import { AvatarTypes } from '../../../designe/app-avatar/AppAvatar';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../designe/app-entity-avatar/AppEntityAvatar';
import theme from '../../../../styles/theme';
import { useStyles } from './UserSmallItem.styles';
import clsx from 'clsx';
import { IUser } from '../../../../types/interfaces/user';

interface UserSmallItemProps {
  user: IUser;
  onUserClick?: (user: IUser) => void;
  borderOnHover?: boolean;
}

export default function UserSmallItem(props: UserSmallItemProps) {
  const { user, onUserClick, borderOnHover } = props;
  const { classes } = useStyles(theme);

  function clickOnUserHandler() {
    if (onUserClick) {
      onUserClick(user);
    }
  }

  return (
    <div
      className={clsx(
        classes.userWrapper,
        borderOnHover && classes.userWrapperHover,
      )}
      onClick={clickOnUserHandler}>
      <AppEntityAvatar
        entity={user}
        size={AvatarSize.m}
        type={AvatarTypes.round}
      />
      <div className={classes.infoWrapper}>
        <div
          className={
            classes.infoName
          }>{`${user.firstname} ${user.lastname}`}</div>
      </div>
    </div>
  );
}
